// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__CQc8N","paymentContainer":"PaymentPage_paymentContainer__yj_D4"};